import React from 'react';
import { AccountBox, Business, ListAlt } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import PaperForm from 'ui/form/PaperForm';
import EditSectionForm from 'ui/form/EditSectionForm';
import Avatars from 'ui/Avatars';
import { getCountryName, getRegionName } from 'utils/county-data';

import BusinessPart from '../parts/BusinessPart';
import TeamPart from '../parts/TeamPart';
import LicensePart from '../parts/LicensePart';

import { AGREE_FIELDS, isCustomerType, SUBSCRIPTIONS } from '../consts';

const useStyles = makeStyles(theme => ({
    root: {
        marginBottom: theme.spacing(3),
    },
}));

export default function EditStep({
    values,
    changes,
    errors,
    onCancel,
    goNext,
    onChange,
    extra,
}) {
    const classes = useStyles();
    const agreeRequired = AGREE_FIELDS.some(name => changes.includes(name));
    const onChangeLicense = (name, value) => {
        if (name === 'seats') {
            value = parseInt(value, 10) || '';
        }
        onChange(name, value);
    };
    const isNotCustomer = !isCustomerType(values.type);

    const removeEmptyValues = (...values) =>
        [...values]
            .filter(
                value => value !== undefined && value !== null && value !== ''
            )
            .join(', ');
    const addressValue = removeEmptyValues(values.address1, values.address2);
    const cityValue = removeEmptyValues(
        values.city,
        getRegionName(values.country, values.region),
        values.postal_code
    );
    const countryValue = removeEmptyValues(getCountryName(values.country));

    return (
        <PaperForm title="Settings">
            <EditSectionForm
                title={'Business'}
                icon={Business}
                canEdit={extra.editable}
                onSubmit={goNext}
                onCancel={onCancel}
                showEditIcon
                classes={classes}
            >
                <EditSectionForm.Preview showEditIcon>
                    <EditSectionForm.PreviewItem value={values.business_name} />
                    {isNotCustomer && (
                        <React.Fragment>
                            {addressValue && (
                                <EditSectionForm.PreviewItem>
                                    <div>{addressValue}</div>
                                </EditSectionForm.PreviewItem>
                            )}
                            {cityValue && (
                                <EditSectionForm.PreviewItem
                                    value={cityValue}
                                />
                            )}
                            {countryValue && (
                                <EditSectionForm.PreviewItem
                                    value={countryValue}
                                />
                            )}
                        </React.Fragment>
                    )}
                </EditSectionForm.Preview>
                <EditSectionForm.Form>
                    <BusinessPart
                        values={values}
                        errors={errors}
                        onChange={onChange}
                    />
                </EditSectionForm.Form>
            </EditSectionForm>

            <EditSectionForm
                title="Business profile name and logo"
                icon={AccountBox}
                canEdit={extra.editable}
                onSubmit={goNext}
                onCancel={onCancel}
                showEditIcon
                classes={classes}
            >
                <EditSectionForm.Preview showEditIcon>
                    <EditSectionForm.PreviewItem value={values.name} />
                    <Avatars.Normal
                        src={values.logo}
                        color={values.color}
                        name={values.business_name}
                    />
                </EditSectionForm.Preview>
                <EditSectionForm.Form>
                    <TeamPart
                        values={values}
                        errors={errors}
                        onChange={onChange}
                    />
                </EditSectionForm.Form>
            </EditSectionForm>

            <EditSectionForm
                title="License"
                icon={ListAlt}
                canEdit={extra.editable}
                onSubmit={goNext}
                onCancel={onCancel}
                classes={classes}
            >
                <EditSectionForm.Preview showEditIcon>
                    <EditSectionForm.PreviewItem
                        label="Subscription Level"
                        value={SUBSCRIPTIONS[values.subscription_level]}
                    />
                    <EditSectionForm.PreviewItem
                        label="Users"
                        value={values.seats}
                    />
                </EditSectionForm.Preview>
                <EditSectionForm.Form>
                    <LicensePart
                        values={values}
                        errors={errors}
                        onChange={onChangeLicense}
                        agree={agreeRequired}
                    />
                </EditSectionForm.Form>
            </EditSectionForm>
        </PaperForm>
    );
}
